function initInlineLifestyleBlocks(sectionId, defaultSort) {
  var store = document.getElementById('lifestyle-blocks-store-' + sectionId);
  if (!store) return;

  var grid, observer, injectTimer, resizeTimer;

  function getOrder(block) {
    var w = window.innerWidth;
    var sm = parseInt(block.dataset.orderSm, 10);
    var md = parseInt(block.dataset.orderMd, 10);
    var lg = parseInt(block.dataset.orderLifestyle, 10);
    if (w < 768 && sm) return sm;
    if (w < 992 && md) return md;
    return lg || 999;
  }

  function initVideos(container) {
    container.querySelectorAll('video').forEach(function(video) {
      video.muted = true;
      video.load();
      video.play().catch(function() {});
    });
  }

  // Parse the active spf-col-* span number for the current viewport.
  // e.g. spf-col-xl-4 at >=1200px -> 4
  function getSpfColSpan(classes) {
    var w = window.innerWidth;
    var bpOrder = ['xl', 'lg', 'md', 'sm', ''];
    var bpMin   = { xl: 1200, lg: 992, md: 768, sm: 576, '': 0 };
    var colMap  = {};
    classes.forEach(function(c) {
      var m = c.match(/^spf-col(?:-([a-z]+))?-(\d+)$/);
      if (m) colMap[m[1] || ''] = parseInt(m[2], 10);
    });
    for (var i = 0; i < bpOrder.length; i++) {
      var bp = bpOrder[i];
      if (w >= bpMin[bp] && colMap[bp] !== undefined) return colMap[bp];
    }
    return null;
  }

  function isFiltered() {
    if (window.globofilter && window.globofilter.state && window.globofilter.state.queryParams) {
      var qp = window.globofilter.state.queryParams;
      if (qp.filter && Object.keys(qp.filter).length > 0) return true;
      if (qp.currentTags && qp.currentTags.length > 0) return true;
      if (qp.form && Object.keys(qp.form).length > 0) return true;
      if (defaultSort && qp.sort_by && qp.sort_by !== defaultSort) return true;
      return false;
    }
    // Fallback: URL params (Shopify native filtering / non-Globo templates)
    var search = window.location.search;
    return search.indexOf('filter.') !== -1 || /[?&]gf_/.test(search) || /[?&]sort_by=/.test(search);
  }

  function injectBlocks() {
    if (!grid) return;
    clearTimeout(injectTimer); // cancel any observer-queued re-run
    observer.disconnect();
    grid.querySelectorAll('.inline-lifestyle-block-wrapper, .inline-lifestyle-block').forEach(function(el) {
      if (el.parentNode === grid) el.remove();
    });
    if (isFiltered()) {
      observer.observe(grid, { childList: true });
      return;
    }
    var products = Array.from(grid.children).filter(function(el) {
      return !el.classList.contains('inline-lifestyle-block') && !el.classList.contains('inline-lifestyle-block-wrapper');
    });

    // Wrap in a div matching sibling spf-col-* classes so padding doesn't bleed into the absolutely-positioned image
    var spfColClasses = products.length
      ? Array.from(products[0].classList).filter(function(c) { return c.indexOf('spf-col') === 0; })
      : [];

    Array.from(store.children)
      .sort(function(a, b) { return getOrder(a) - getOrder(b); })
      .forEach(function(block) {
        var target = products[getOrder(block) - 1];
        var clone = block.cloneNode(true);
        var toInsert = clone;
        if (spfColClasses.length) {
          var wrapper = document.createElement('div');
          var isWide = clone.dataset.wideBlock === 'true';
          var isMobile = window.innerWidth < 768;
          var multiplier = (isWide || isMobile) ? 2 : 1;
          spfColClasses.forEach(function(c) { wrapper.classList.add(c); });
          wrapper.classList.add('inline-lifestyle-block-wrapper');
          var singleSpan = getSpfColSpan(spfColClasses);
          if (singleSpan) {
            var totalSpan = Math.min(singleSpan * multiplier, 12);
            var pct = Math.min((totalSpan / 12) * 100, 100).toFixed(4) + '%';
            wrapper.style.flex = '0 0 ' + pct;
            wrapper.style.maxWidth = pct;
            wrapper.style.width = pct;
            wrapper.style.gridColumn = 'span ' + totalSpan;
          }
          wrapper.appendChild(clone);
          toInsert = wrapper;
        }
        if (target) {
          target.parentNode.insertBefore(toInsert, target);
        } else {
          grid.appendChild(toInsert);
        }
        initVideos(toInsert);
      });
    observer.observe(grid, { childList: true });
  }

  document.addEventListener('DOMContentLoaded', function() {
    grid = document.querySelector('.grid-' + sectionId);
    if (!grid) return;
    observer = new MutationObserver(function() {
      clearTimeout(injectTimer);
      injectTimer = setTimeout(injectBlocks, 50);
    });
    injectBlocks();
    observer.observe(grid, { childList: true });
  });

  window.addEventListener('globoFilterRenderCompleted', function() {
    clearTimeout(injectTimer);
    injectBlocks();
  });

  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    clearTimeout(injectTimer); // cancel any pending observer-triggered call too
    resizeTimer = setTimeout(injectBlocks, 200);
  });
}
